import { Injectable } from '@angular/core';
import {first} from "rxjs/operators";
import {JobsiteDataService} from "./jobsite.data.service";

@Injectable({
  providedIn: 'root'
})
export class JobsiteService {

  constructor(
    private jobsiteDataService: JobsiteDataService
  ) {}

  getJobsites = (requestparam:any = {}) => {
    requestparam = { ...requestparam, per_page: 10000 };
    return this.jobsiteDataService.search(requestparam);
  }
}
